const setCurrentModal = set => currentModal => set(state => {
  return {
    ...state,
    currentModal
  };
}, false, 'SET_CURRENT_MODAL');

export default setCurrentModal;
